// @flow

import {havePermission} from "./utils"

export default class RestaurantSettingsPermissions {

  read(proRole:ProRole = null) {
    return havePermission(
      'restaurantSettings',
      proRole
    );
  }

  readPublicInfo(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.publicInfo',
      proRole
    );
  }

  editPublicInfo(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.publicInfo.canEdit',
      proRole
    );
  }

  readMenu(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.menu',
      proRole
    );
  }

  editMenu(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.menu.canEdit',
      proRole
    );
  }

  readOpeningHours(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.openingHours',
      proRole
    );
  }

  editOpeningHours(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.openingHours.canEdit',
      proRole
    );
  }

  readLegal(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal',
      proRole
    );
  }

  readLegalRestaurateur(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal.restaurateur',
      proRole
    );
  }

  editLegalRestaurateur(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal.restaurateur.canEdit',
      proRole
    );
  }

  readLegalSociety(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal.society',
      proRole
    );
  }

  editLegalSociety(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal.society.canEdit',
      proRole
    );
  }

  readLegalRepresentative(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal.representative',
      proRole
    );
  }

  editLegalRepresentative(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.legal.representative.canEdit',
      proRole
    );
  }

  readFinance(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.finance',
      proRole
    );
  }

  readFinanceBankAccount(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.finance.bankAccount',
      proRole
    );
  }

  editFinanceBankAccount(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.finance.bankAccount.canEdit',
      proRole
    );
  }

  /**
   * TODO: to implement
   */
  createFinanceBankAccount(proRole:ProRole = null): boolean {
    return false;
    return havePermission(
      'restaurantSettings.finance.bankAccount.canCreate',
      proRole
    );
  }

  readFinanceOther(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.finance.other',
      proRole
    );
  }

  editFinanceOther(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.finance.other.canEdit',
      proRole
    );
  }

  readFeatures(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.features',
      proRole
    );
  }

  editFeatures(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.features.canEdit',
      proRole
    );
  }

  /**
   * TODO: handle sub permissions read all to false.
   */
  readConfiguration(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration',
      proRole
    );
  }

  readConfigurationGeneral(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.general',
      proRole
    );
  }

  editConfigurationGeneral(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.general.canEdit',
      proRole
    );
  }

  editConfigurationGeneralActivation(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.general.canEditActivation',
      proRole
    );
  }

  readConfigurationPos(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.pos',
      proRole
    );
  }

  editConfigurationPos(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.pos.canEdit',
      proRole
    );
  }

  readConfigurationMangoPay(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.mangoPay',
      proRole
    );
  }

  /**
   * Didn't used for the moment.
   */
  editConfigurationMangoPay(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.mangoPay.canEdit',
      proRole
    );
  }

  readConfigurationCommission(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.commission',
      proRole
    );
  }

  editConfigurationCommission(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.configuration.commission.canEdit',
      proRole
    );
  }

  readTheme(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.theme',
      proRole
    );
  }

  editTheme(proRole:ProRole = null): boolean {
    return havePermission(
      'restaurantSettings.theme.canEdit',
      proRole
    );
  }
}
